import { Badge } from '@mantine/core';
import { i18nKeys } from 'locales/index';
import { useTranslation } from 'locales/logic';
import type { ReminderSendingMedia } from 'types/reminder-sending-media';

const mediumToColor: Record<ReminderSendingMedia, string> = {
  email: 'grape',
  post: 'yellow',
  registered_post: 'orange',
  missing_information: 'gray',
  ai_call: 'blue',
};

interface SentMediumBadgeProps {
  sentMedium: ReminderSendingMedia;
}

export const SentMediumBadge = ({ sentMedium }: SentMediumBadgeProps) => {
  const { t } = useTranslation();

  return (
    <Badge size="xs" color={mediumToColor[sentMedium]} variant="light">
      {t((i18nKeys.REMINDER_LIST.BADGE as any)[sentMedium.toUpperCase()])}
    </Badge>
  );
};
